"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { httpBatchLink, loggerLink } from "@trpc/client";
import { createTRPCReact } from "@trpc/react-query";
import { useState } from "react";
import type { AppRouter } from "~/server/api/root";
import { getUrl, transformer } from "./shared";
export const api = createTRPCReact<AppRouter>();
export function TRPCReactProvider(props) {
  const $ = _c(9);
  const [queryClient] = useState(_temp);
  let t0;
  if ($[0] !== props.headers) {
    t0 = () => api.createClient({
      links: [loggerLink({
        enabled: _temp2
      }), httpBatchLink({
        transformer,
        url: getUrl(),
        headers() {
          const heads = new Map(props.headers);
          heads.set("x-trpc-source", "react");
          return Object.fromEntries(heads);
        }
      })]
    });
    $[0] = props.headers;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [trpcClient] = useState(t0);
  let t1;
  if ($[2] !== props.children || $[3] !== queryClient || $[4] !== trpcClient) {
    t1 = <api.Provider client={trpcClient} queryClient={queryClient}>{props.children}</api.Provider>;
    $[2] = props.children;
    $[3] = queryClient;
    $[4] = trpcClient;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== queryClient || $[7] !== t1) {
    t2 = <QueryClientProvider client={queryClient}>{t1}</QueryClientProvider>;
    $[6] = queryClient;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp2(op) {
  return process.env.NODE_ENV === "development" || op.direction === "down" && op.result instanceof Error;
}
function _temp() {
  return new QueryClient();
}